(() => {
  const optionSelectors = ['select[name^="options"]', 'input[type="radio"][name^="options"]'];
  let savedPosition = 0;

  const save = () => {
    savedPosition = window.scrollY || window.pageYOffset || 0;
  };

  const restore = () => {
    window.scrollTo(0, savedPosition);
  };

  document.addEventListener('touchstart', save, { passive: true });
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (optionSelectors.some((sel) => target.matches(sel))) {
      save();
    }
  });

  document.addEventListener('variant:change', () => {
    setTimeout(restore, 0);
  });
})();
